export type TutorialStep = {
    selector?: string;
    message: string;
    image?: string;
    isMustClick?: boolean;
    isMustClickWithNoAction?: boolean;
    timeOut?: number;
    hidePopover?: boolean;
    title?: string;
};

export const tutorialFlows1: Record<string, TutorialStep[]> = {
    // 🧸 1️⃣ INTRO FLOW (Chose Guardian page)
    introFlow: [
        {
            title: `Cyborg Bear Introduction`,
            message: `Welcome to Scam Protect, I am Cyborg Bear, your guardian against scammers.
      I am here to assist you in all your anti-scam needs and to help you with scam identification 
      to keep you and your valuables safe.`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `Cyborg Bear Introduction`,
            message: `Since this is your first time using Scam Protect, let me orientate you towards the Scam Protect interface.
      You can go back to the previous instruction by clicking the "previous" button. To continue with the introduction, please click the "Pinging circle"`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".tutorial-skip-btn",
            message: `You may skip the introduction by clicking on the “Skip Introduction” button at any time.`,
            image: `cyborg-bear-1.png`,
            isMustClick: true
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".guardian-arrow-right",
            message: `You can select to change your guardian later after this tutorial if you wish.`,
            image: `cyborg-bear-1.png`,
            isMustClick: true,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".choose-guardian-btn",
            message: `You can select to change your guardian later after this tutorial if you wish.`,
            image: `cyborg-bear-1.png`,
            isMustClickWithNoAction: true
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".guardian-communication-box",
            message: `Incoming communications from your requests or actions will be captured here.
      Your guardian will be your guide and companion.`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".incoming-message-box",
            message: `System messages that you may find useful will be displayed here. 
      We will keep you updated on important system messages here.`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".interaction-interface-box",
            message: `This is the interaction interface.
      Your session history with your guardian will be recorded here for your easy reference.
      Saved files will be archived and can be used to send to external parties for scam reporting or analysis.`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".save-history-btn",
            message: `If you would like to save your interaction history, please click the save button here.
      Saved interaction histories will go into the Archives.`,
            image: `cyborg-bear-1.png`,
            isMustClickWithNoAction: true
        },
    ],

    // 🕵️ 2️⃣ SCAM IDENTIFY FLOW (StartIdentifyScam page)
    scamIdentifyFlow: [
        //   {
        //       message: `This page represents the scam identification function.
        // Options to guide you towards identifying potential scam scenarios will be displayed here.`,
        //       image: `cyborg-bear-1.png`,
        //   },

        {
            title: `Cyborg Bear Introduction`,
            selector: ".top-menu-bar",
            message: `The Top menu bar offers options to bring up the functionality you wish to utilize in Scam Protect.`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".menu-choose-guardian",
            message: `As you can see, it is currently displaying the "choose your guardian" functionality.`,
            image: `cyborg-bear-1.png`,
            isMustClickWithNoAction: true
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".menu-scam-identification",
            message: `Over here, Scam Protect uses The Wisdom Approach to create elemental fingerprints of “a lie” and “the truth” to accurately identify scams. 
            In many cases, it is possible to identify scams with complete accuracy. Once a scam is identified, you can protect yourself by avoiding it and reporting it to help others`,
            image: `cyborg-bear-1.png`,
            isMustClickWithNoAction: true
            // isMustClick: true,
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".fingerprint-scan-btn",
            message: `This page represents the scam identification function. 
            Your guardian will guide you towards obtaining information to identify any potential scam scenario you are facing. Information and options will be displayed in the centre once you start the scam identification process. 
            To start the scam identification process, simply click on the scam identification fingerprint`,
            image: `cyborg-bear-1.png`,
            // isMustClick: true,
            isMustClickWithNoAction: true
        },
        {
            title: `Cyborg Bear Introduction`,
            selector: ".menu-scam-education",
            message: `This is the Scam Education Tab, When completed, you will find materials that will educate and help you to protect yourself against scammers.`,
            isMustClick: true,
            image: `cyborg-bear-1.png`,
            hidePopover: true
        },
        //   {
        //       selector: ".disclaimer-ok-button",
        //       message: `After reading the disclaimer, click OK to continue.`,
        //       image: `cyborg-bear-1.png`,
        //   },
        //   {
        //       selector: ".center-question-box",
        //       message: `A separate scam identification tutorial will be made available for your benefit.
        // You can access it anytime from the main interface.`,
        //       image: `cyborg-bear-1.png`,
        //   },
    ],

    // 🎓 3️⃣ SCAM EDUCATION FLOW (/scam-education)
    scamEducationFlow: [
        {
            // selector: ".menu-scam-education",
            title: `Cyborg Bear Introduction`,
            message: `You are now in the “scam education” function. 
            This is where you can find information about scam statistics, and information that will help you gain capabilities to protect yourself from scams. 
            Explore this section to improve your scam-resistance level.`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `supper puppy Introduction`,
            // selector: ".menu-anti-scam-defenders",
            message: `Whenever you use Scam Protect more and explore its functions, including education, you can be awarded with achievement points and level up the Guardians protecting you`,
            image: `supper_puppy.png`,
        },
        {
            title: `supper puppy Introduction`,
            selector: ".menu-anti-scam-defenders",
            message: `This is anti scam defenders.`,
            image: `supper_puppy.png`,
            isMustClick: true,
            hidePopover: true
        },
    ],

    // 🐻‍❄️ 4️⃣ ANTI SCAM DEFENDERS FLOW (/anti-scam-defenders)
    antiScamFlow: [
        {
            title: `The Twins - Kungfu Bears Introduction`,
            message: `You are now in the “anti-scam defences” function. 
            This is where scam protect uses Artificial Intelligence to utilized information collected to provide with scam blocking and filtering defences.
             You can also check for known scams that have been recorded in our databases and our affiliates’ databases. Please note that AI relies on data and cannot provide with full protection. 
             You should use our scam checking function if you have specific information like a phone number or email to check for known reported scams. 
            To protect yourself from any scam, we recommend using the scam identification function as this utilize a logic approach that is robust if the process is followed correctly.`,
            image: `kungfu_bear.png`,
        },
        {
            title: `The Twins - Kungfu Bears Introduction`,
            selector: ".menu-contribution-community",
            message: `This is Contribution and community`,
            image: `kungfu_bear.png`,
            isMustClick: true,
            hidePopover: true
        },
    ],

    // 🐼 5️⃣ COMMUNITY FLOW (/contribution-community)
    communityFlow: [
        {
            title: `P & P Observation Unit: Poodie and Panda Introduction`,
            message: `You are now in the “contribution and community” function. 
            This is where you can access links to forums and communities talking about scams and how to protect oneself from scams. 
            You can also choose to “report a scam” here, or donate to vetted individuals and organizations actively trying to bring the fight to the scammers.`,
            image: `poodie_and_panda.png`,
        },
        {
            title: `Zombie Myles Introduction`,
            message: `I am Myles, Zombie Myles!
      When you help fight scammers, I will be there to GAAA the scammers into submission.`,
            image: `zombie-myles-1.png`,
        },
        {
            title: `Zombie Myles Introduction`,
            selector: ".menu-archives",
            message: `This is the Archives function.`,
            image: `zombie-myles-1.png`,
            isMustClick: true,
            hidePopover: true
        },
    ],

    // 📂 6️⃣ ARCHIVES FLOW (/archives)
    archivesFlow: [
        {
            title: `Cyborg Bear Introduction`,
            message: `This is the archives function. 
            All your saved interaction sessions will be displayed here according to a serial number, the date and time. 
            You can use the copy button to paste the text of each archive into messages for your desired purpose.`,
            image: `cyborg-bear-1.png`,
        },
        {
            title: `Cyborg Bear Introduction`,
            message: `This wraps up the tutorial for navigating scam protect. You can review the tutorial again whenever you desire. 
            The tutorial allows you to jump to specific sections of the tutorial for your convenience. 
            This means you are able to directly review the sections you need information about`,
            image: `cyborg-bear-1.png`,

        },
    ],
};

export function startTutorialFlow(navigate: any, flowName: string, tutorialStep?: number) {
    navigate(getPageUrlForFlow(flowName));
    localStorage.setItem(
        "tutorialProgress",
        JSON.stringify({
            currentFlow: flowName,
            currentStep: tutorialStep ?? 0,
        })
    );
    localStorage.removeItem("hasCompletedTutorial");
}

export const getPageUrlForFlow = (flowName: string) => {
    switch (flowName) {
        case "introFlow":
            return "/choose-guardian";
        case "scamIdentifyFlow":
            return "/StartIdentifyScam";
        // return "/chose-guardian";
        case "scamEducationFlow":
            return "/scam-education";
        case "antiScamFlow":
            return "/anti-scam-defenders";
        case "communityFlow":
            return "/contribution-community";
        case "archivesFlow":
            return "/archives";
        default:
            return "/";
    }
};